// Shared helpers for all quote layout archetypes.

export const formatEUR = (n) =>
  (Number(n) || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';

// Effektiver Einzelpreis einer Position unter Berücksichtigung der vom Kunden
// gewählten Alternative (neues + altes System) und customPrice.
export const effectiveUnitPrice = (service, selectedAlternatives = {}) => {
  let price = service.customPrice !== null && service.customPrice !== undefined ? service.customPrice : service.price;
  if (service.hasAlternative && selectedAlternatives[service.id] === 'alternative' && service.alternativePrice) {
    price = service.alternativePrice;
  } else if (service.alternatives && service.alternatives.length > 0) {
    const selId = selectedAlternatives[service.id] || service.selectedAlternativeId;
    if (selId && selId !== 'main') {
      const alt = service.alternatives.find(a => a.id === selId);
      if (alt) price = alt.price;
    }
  }
  return price || 0;
};

// Zeilensumme einer Position: Alternative → Staffelpreis → Menge → Einzelrabatt.
// Spiegelt exakt die Logik aus PublicQuoteView.calculateTotals (pro Service).
export const serviceLineTotal = (service, { selectedAlternatives = {}, localQuantities = {} } = {}) => {
  const effectivePrice = effectiveUnitPrice(service, selectedAlternatives);
  const qty = localQuantities[service.id] !== undefined ? localQuantities[service.id] : service.quantity;
  let total;
  // Ein im Kalkulator gesetzter Einzelpreis schlaegt die Katalog-Staffel — sonst
  // zeigt das Angebot trotz Speichern weiter den Katalogpreis.
  const hasCustomPrice = service.customPrice !== null && service.customPrice !== undefined;
  if (!hasCustomPrice && service.priceTiers && service.priceTiers.length > 0) {
    const tier = service.priceTiers.find(t => t.upTo === null || qty <= t.upTo) || service.priceTiers[service.priceTiers.length - 1];
    total = (tier.pricePerUnit ?? effectivePrice) * qty;
  } else {
    total = effectivePrice * qty;
  }
  if (service.customDiscount?.value > 0) {
    total = service.customDiscount.type === 'percentage'
      ? total * (1 - service.customDiscount.value / 100)
      : Math.max(0, total - service.customDiscount.value);
  }
  return total;
};

// Preis-Anzeige einer Position. Positionen mit Preisspanne (priceMax) zeigen
// "X – Y €"; GERECHNET (Summen, Annahme) wird immer mit dem unteren Wert —
// der ist verbindlich, Abweichungen nach oben nur nach Freigabe (Disclaimer).
export const priceLabel = (service, total) => {
  const max = Number(service?.priceMax);
  if (max && max > (Number(service?.price) || 0)) {
    const qty = service.quantity || 1;
    return `${formatEUR(total)} – ${formatEUR(max * qty)}`;
  }
  return formatEUR(total);
};
